import { UserFieldResponse } from './field/user-field-response';
import * as fp from 'lodash/fp';

export class Booking {
  static fromAny(data: any) {
    return new Booking(
      data.clientLocalDateTime,
      data.dateTimeUTC,
      data.checkIn,
      data.geoPosition,
      data.longitude,
      data.latitude,
      data.additional,
      data.allocationId,
      data.terminalIdentifier,
      data.personIdentifier,
      data.bookingCodeId,
      data.userFieldResponses
    );
  }

  constructor(
    public clientLocalDateTime: string,
    public dateTimeUTC: string | null,
    public checkIn: boolean,
    public geoPosition: string | null = 'UNKNOWN',
    public longitude: string | null = '-1',
    public latitude: string | null = '-1',
    public additional: string,
    public allocationId: string | null = null,
    public terminalIdentifier: string,
    public personIdentifier: string,
    public bookingCodeId: string | null = null,
    public userFieldResponses: Array<UserFieldResponse>
  ) {
    this.geoPosition = this.geoPosition || null;
    this.latitude = this.latitude || null;
    this.longitude = this.longitude || null;
  }

  static equals(a: any, b: any) {
    if (!a || !b) return false;
    return fp.isEqual(Booking.fromAny(a), Booking.fromAny(b));
  }
}
